import { Component, OnInit, Input } from '@angular/core';
import { Report } from 'src/app/model';

@Component({
  selector: 'link-access',
  templateUrl: './link-access.component.html',
  styleUrls: ['./link-access.component.scss']
})

export class LinkAccessComponent implements OnInit {

  @Input() report: Report;

  COLLAPSE_ACCESS = true;

  constructor() { }

  ngOnInit(): void {
    if(!this.report.LINK_ACCESS){
      this.report.LINK_ACCESS = [];
    }
  }
}
